export default __webpack_public_path__ + "static/media/dog-with-balls.3a1387f8.png";